import { capitalized, cn, putComma } from "@/lib/utils";

import { IoIosStar } from "react-icons/io";
import React, { useEffect, useState } from "react";
import moment from "moment";
import Link from "next/link";
import Actions from "@/elements/Actions";
import Image from "next/image";
import { Mixpanel } from "@/elements/Mixpanel";
import { useRouter } from "next/router";

const StocksExtra = ({ isPaidUserPage, data, seoData, shareHoldingData, peerComparison }) => {
    const router = useRouter();
    const finCode = data?.finCode;
    const symbol = `${data?.compName} (${data?.title})`;
    const monthWiseTicks = [...(seoData?.monthWiseTicks ?? [])]?.reverse();
    const yearEndingMonth = [...(seoData?.yearEndingMonth ?? [])]?.reverse();

    // console.log(data);
    // console.log(seoData);
    const performanceData = [
        { label: "Opening Price:", value: putComma(data?.nseTodaysOpen ?? data?.bseTodaysOpen) },
        { label: "Previous closing Price:", value: putComma(data?.nseClosePrice ?? data?.bseClosePrice) },
        { label: `Volume of ${symbol} share:`, value: putComma(seoData?.keyIndicators?.volume, 0) },
        { label: "Value of Share:", value: putComma(data?.nseLtpPrice ?? data?.bseLtpPrice) }
    ];

    const fundamentalsData = [
        { label: "Market Capitalisation:", value: `${putComma(seoData?.keyIndicators?.marketCapital, 0)} Cr.` },
        { label: "P/E Ratio:", value: putComma(seoData?.keyIndicators?.peRatio) },
        { label: "P/B Ratio:", value: putComma(seoData?.keyIndicators?.pbRatio) },
        { label: "Sector P/E:", value: putComma(seoData?.keyIndicators?.sectorPE) },
        // { label: "ROE:", value: putComma(seoData?.keyIndicators?.marketCapital) },
        { label: "EPS (TTM):", value: putComma(seoData?.keyIndicators?.eps) },
        { label: "Dividend Yield:", value: putComma(seoData?.keyIndicators?.divYield) },
        { label: "14D - RSI:", value: putComma(seoData?.keyIndicators?.fourteenDaysRSI) },
        { label: "50 DMA:", value: putComma(seoData?.keyIndicators?.fiftyDMA) },
        { label: "200 DMA:", value: putComma(seoData?.keyIndicators?.twoHundredDMA) }
    ];

    // const companyInformation = [
    //     {
    //         segment: "Oil to Chemical (O2C)",
    //         description:
    //             "Oil-to-chemical (O2C) segment of Reliance includes oil refineries, petrochemical facilities, and petrol retailing. It includes the refinery off-gas aromatics, crackers, multi-fuel, gasification, and gas streams. It also comprises downstream facility of manufacturing and infrastructure supply-chain, and logistics."
    //     },
    //     {
    //         segment: "Oil and Gas",
    //         description: "This segment comprises exploring, developing, along producing natural gases and crude oils."
    //     },
    //     {
    //         segment: "Retail",
    //         description:
    //             "Retail segment of Reliance industries Ltd. deals with consumer retailing and other similar services the company offers."
    //     },
    //     {
    //         segment: "Digital Services",
    //         description:
    //             "Digital segment deals with offering digital services to the consumers. This sector of Reliance provides a high-quality service at a competitive price, never sacrificing quality or assembly performance."
    //     },
    //     {
    //         segment: "Financial Services",
    //         description:
    //             "The Financial Services vertical is responsible for the administration and deployment of the Company's financial resources across various operations, such as non-banking financial services and insurance services."
    //     }
    // ];
    // const companyContactInfo = [
    //     "Registered Reliance Office – 3rd Floor Maker Chambers IV, 222 Nariman Point, Mumbai – India",
    //     "FAX Number – 91-22-22042268 / 22852214",
    //     "Phone Number – 91-22-22785000 / 35555000",
    //     "Email ID – Investor.Relations@ril[dot]com"
    // ];
    // const otherCompanyInfo = [
    //     "Corporate Reliance Office – Maker Chambers – IV, Nariman Point, Mumbai – India",
    //     "India Phone Number – 91-22-22785000",
    //     "Email ID – Info@ril[dot]com"
    // ];
    // const managementData = [
    //     { designation: "Non-Executive Director", name: "Adil Zainulbhai" },
    //     { designation: "Chief Financial Officer", name: "Alok Agarwal" },
    //     { designation: "Non-Executive Director", name: "Arundhati Bhattacharya" }
    // ];

    // const Indices = [
    //     { key: "MCXSX40Index", value: "MCX-SX 40 Index" },
    //     { key: "NIFTY100", value: "NIFTY 100" },
    //     { key: "NIFTY100Liquid15", value: "NIFTY 100 Liquid 15" },
    //     { key: "NIFTY100LowVolatility30", value: "NIFTY 100 Low Volatility 30" },
    //     { key: "NIFTY200", value: "NIFTY 200" },
    //     { key: "NIFTY50", value: "NIFTY 50" },
    //     { key: "NIFTY50EqualWeight", value: "NIFTY 50 Equal Weight" },
    //     { key: "NIFTY500", value: "NIFTY 500" },
    //     { key: "NIFTY500Multicap50_25_25Index", value: "NIFTY 500 Multicap 50:25:25 Index" },
    //     { key: "NIFTYAlpha50", value: "NIFTY Alpha 50" },
    //     { key: "NIFTYAlphaLowVolatility30", value: "NIFTY Alpha Low Volatility 30" },
    //     { key: "NIFTYCommodities", value: "NIFTY Commodities" },
    //     { key: "NIFTYEnergy", value: "NIFTY Energy" },
    //     { key: "NIFTYIndiaManufacturingIndex", value: "NIFTY India Manufacturing Index" },
    //     { key: "NIFTYInfrastructure", value: "NIFTY Infrastructure" },
    //     { key: "NIFTYLargeMidcap250", value: "NIFTY LargeMidcap 250" },
    //     { key: "NIFTYOilAndGas", value: "NIFTY Oil & Gas" },
    //     { key: "NIFTY100EqualWeight", value: "NIFTY100 Equal Weight" },
    //     { key: "NIFTY50USD", value: "NIFTY50 USD" },
    //     { key: "SPBSE100", value: "S&P BSE 100" },
    //     { key: "SPBSE100ESGIndex", value: "S&P BSE 100 ESG Index" },
    //     { key: "SPBSE100LargeCapTMCIndex", value: "S&P BSE 100 LargeCap TMC Index" },
    //     { key: "SPBSE200", value: "S&P BSE 200" },
    //     { key: "SPBSE250LargeMidCapIndex", value: "S&P BSE 250 LargeMidCap Index" },
    //     { key: "SPBSE500", value: "S&P BSE 500" },
    //     { key: "SPBSEAllCap", value: "S&P BSE AllCap" },
    //     { key: "SPBSECarbonex", value: "S&P BSE Carbonex" },
    //     { key: "SPBSEDividendStabilityIndex", value: "S&P BSE Dividend Stability Index" },
    //     { key: "SPBSEDollex100", value: "S&P BSE Dollex – 100" },
    //     { key: "SPBSEDollex200", value: "S&P BSE Dollex – 200" },
    //     { key: "SPBSEDollex30", value: "S&P BSE Dollex – 30" },
    //     { key: "SPBSEEnergy", value: "S&P BSE Energy" },
    //     { key: "SPBSEIndiaManufacturing", value: "S&P BSE India Manufacturing" },
    //     { key: "SPBSELargeCap", value: "S&P BSE LargeCap" },
    //     { key: "SPBSELargeMidCap", value: "S&P BSE LargeMidCap" },
    //     { key: "SPBSEOilAndGas", value: "S&P BSE Oil & Gas" },
    //     { key: "SPBSESensex", value: "S&P BSE Sensex" },
    //     { key: "SPBSESensex50", value: "S&P BSE Sensex 50" },
    //     { key: "SPBSETASISShariah50", value: "S&P BSE TASIS Shariah 50" }
    // ];
    const stockExchanges = [
        { key: "BangaloreStockExchangeLtd", value: "Bangalore Stock Exchange Ltd." },
        { key: "CalcuttaStockExchangeAssocLtd", value: "Calcutta Stock Exchange Association Ltd." },
        { key: "CochinStockExchangeLtd", value: "Cochin Stock Exchange Ltd." },
        { key: "DelhiStockExchangeAssocLtd", value: "Delhi Stock Exchange Assoc. Ltd." },
        { key: "HyderabadStockExchangeLtd", value: "Hyderabad Stock Exchange Ltd" },
        { key: "InterConnectedStockExchangeOfIndia", value: "Inter-connected Stock Exchange of India" },
        { key: "JaipurStockExchangeLtd", value: "Jaipur Stock Exchange Ltd" },
        { key: "LudhianaStockExchangeAssocLtd", value: "Ludhiana Stock Exchange Assoc. Ltd." },
        { key: "MadrasStockExchangeLtd", value: "Madras Stock Exchange Ltd." },
        { key: "MCXStockExchange", value: "MCX Stock Exchange" },
        { key: "NationalStockExchangeOfIndiaLtd", value: "National Stock Exchange of India Ltd." },
        { key: "OverTheCounterExchangeOfIndiaLtd", value: "Over The Counter Exchange Of India Ltd." },
        { key: "TheStockExchangeMumbai", value: "The Stock Exchange, Mumbai" },
        { key: "UttarPradeshExchangeAssocLtd", value: "Uttar Pradesh Exchange Assoc Ltd." }
    ];

    const shareholdingPattern = [
        {
            type: "Promoters",
            percentage: `${shareHoldingData?.[0]?.promoters?.toFixed(2)}%`
        },
        {
            type: "Foreign Institutions",
            percentage: `${shareHoldingData?.[0]?.foreignInstitutions?.toFixed(2)}%`
        },
        {
            type: "Retail and Others",
            percentage: `${(shareHoldingData?.[0]?.others + shareHoldingData?.[0]?.retail)?.toFixed(2)}%`
        },
        {
            type: "Other Domestic Institutions",
            percentage: `${shareHoldingData?.[0]?.domesticInstitutions?.toFixed(2)}%`
        },
        {
            type: "Mutual Funds",
            percentage: `${shareHoldingData?.[0]?.mutualFunds?.toFixed(2)}%`
        }
    ];

    return (
        <div className={cn("p-4", { hidden: isPaidUserPage, symbol, finCode })}>
            <div className="text-sm lg:text-2xl font-bold mb-4 line-clamp-1">{symbol} Share Price Today</div>

            <div className="border rounded-lg overflow-hidden mb-6">
                <div className="bg-white px-4 py-2 font-semibold text-black font-Inter text-sm lg:text-base capitalize">
                    Performance Of {symbol} Share Today
                </div>
                <table className="w-full text-left text-gray-800">
                    <tbody>
                        {performanceData.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                                <td className="max-w-[86px] min-w-[86px] text-black font-Inter text-xs lg:text-sm font-semibold  gap-2.5 self-stretch pl-6 pr-0 py-3">
                                    {item.label}
                                </td>
                                <td className="py-2 text-black font-Inter text-xs lg:text-sm font-semibold">
                                    {item.value}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <div className="border rounded-lg overflow-hidden mb-6">
                <div className="bg-white px-4 py-2 font-semibold text-black font-Inter text-sm lg:text-base capitalize">
                    Fundamental of {symbol} Share Price
                </div>
                <table className="w-full text-left text-gray-800">
                    <tbody>
                        {fundamentalsData.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                                <td className="max-w-[86px] min-w-[86px] text-black font-Inter text-xs lg:text-sm font-semibold  gap-2.5 self-stretch pl-6 pr-0 py-3">
                                    {item.label}
                                </td>
                                <td className="py-2 text-black font-Inter text-xs lg:text-sm font-semibold">
                                    {item.value}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>

            <p className="text-[#747474] font-Inter text-sm lg:text-base italic font-normal mb-6">
                <strong className="text-black">Note:</strong> The above data is mentioned as per the {symbol} share
                price today.
            </p>

            {data?.nseSymbol && (
                <div className="mb-6">
                    <h2 className="text-base lg:text-xl font-bold mb-2 self-stretch text-black font-Inter">
                        {`${symbol} Share Price Today At NSE`}
                    </h2>
                    <ul className="text-xs lg:text-sm font-semibold list-none text-[#747474] font-Inter">
                        <ul className="text-xs lg:text-sm list-none text-[#747474] font-Inter font-semibold">
                            <li>{`Live ${symbol} Share Price NSE India: ₹${putComma(data?.nseLtpPrice)}`}</li>
                            <li>{`Previous Closing Price: ₹${putComma(data?.nseClosePrice)}`}</li>
                            <li>{`Open Price: ₹${putComma(data?.nseTodaysOpen)}`}</li>
                            <li>{`High: ₹${putComma(data?.nseTodaysHigh)}`}</li>
                            <li>{`Low: ₹${putComma(data?.nseTodaysLow)}`}</li>
                        </ul>
                    </ul>
                </div>
            )}

            {data?.bseSymbol && (
                <div className="mb-6">
                    <h2 className="text-base lg:text-xl mb-2 self-stretch text-black font-Inter font-bold">
                        {`${symbol} Share Price Today At BSE`}
                    </h2>
                    <ul className="text-xs lg:text-sm list-none text-[#747474] font-Inter font-semibold">
                        <li>{`Live ${symbol} Share Price BSE India: ₹${putComma(data?.bseLtpPrice)}`}</li>
                        <li>{`Previous Closing Price: ₹${putComma(data?.bseClosePrice)}`}</li>
                        <li>{`Open Price: ₹${putComma(data?.bseTodaysOpen)}`}</li>
                        <li>{`High: ₹${putComma(data?.bseTodaysHigh)}`}</li>
                        <li>{`Low: ₹${putComma(data?.bseTodaysLow)}`}</li>
                    </ul>
                </div>
            )}

            {!isPaidUserPage && (
                <div className="py-4">
                    <Image
                        alt="demo image"
                        src={
                            "https://storage.googleapis.com/production-univest/pn_images/1743077058844_broker_kyc.jpeg"
                        }
                        width={1200}
                        height={600}
                        className="object-contain rounded-lg md:rounded-2xl cursor-pointer"
                        onClick={() => {
                            router.push("/user/broker-kyc");
                            Mixpanel.track("banner_clicked", {
                                page: "stock_page",
                                widget: "free_trades",
                                cta_text: "free_trades"
                            });
                        }}
                    />
                </div>
            )}
            {monthWiseTicks?.length > 0 && (
                <>
                    <h2 className="text-base lg:text-xl font-bold mb-1 self-stretch text-black font-Inter">
                        {`Historical Price Of ${symbol} Share`}
                    </h2>
                    <p className="text-xs lg:text-sm font-normal list-none text-[#747474] font-Inter mb-2">
                        {`The table below shows the variations in ${symbol} share price from ${
                            monthWiseTicks?.[0]?.monthYear
                        } to ${monthWiseTicks?.[monthWiseTicks?.length - 1]?.monthYear}.`}
                    </p>
                    <div className="border rounded-lg overflow-x-auto mb-6">
                        <table className="w-full text-left text-gray-800">
                            <thead>
                                <tr className="bg-white">
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold whitespace-nowrap">
                                        Month & Year
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold whitespace-nowrap">
                                        Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold whitespace-nowrap">
                                        Open Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold whitespace-nowrap">
                                        High Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold whitespace-nowrap">
                                        Low Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold whitespace-nowrap">
                                        Volume (Cr.)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold whitespace-nowrap">
                                        Change %
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {monthWiseTicks?.map((row, index) => (
                                    <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                                        <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold whitespace-nowrap ">
                                            {row.monthYear}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold whitespace-nowrap ">
                                            {putComma(row.price)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold whitespace-nowrap ">
                                            {putComma(row.openPrice)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold whitespace-nowrap 2">
                                            {putComma(row.highPrice)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold whitespace-nowrap ">
                                            {putComma(row.lowPrice)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold whitespace-nowrap ">
                                            {putComma(row.volume, 0)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold whitespace-nowrap ">
                                            {row.change}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </>
            )}

            {/* <div>
                <h2 className="text-base lg:text-xl font-bold mb-2 text-black">{symbol} Company Information</h2>
                <p className="self-stretch text-[#747474] font-Inter text-sm lg:text-base font-semibold">
                    {symbol} Industries Limited is an Indian company that deals in several fields. The company was
                    founded in the year 1973. It is a multinational conglomerate and the largest private corporation in
                    India. "Growth of Life" is the company's motto that keeps up the spirit of {symbol}. Additionally,
                    the company has achieved global leadership in many sectors and continues to bring positive growth
                    and change to the life of people. The segments that the company deals with are as follows:
                </p>
                <ul className="list-disc pl-6 text-sm text-[#747474] font-Inter font-semibold">
                    {companyInformation.map((info, index) => (
                        <li key={index} className="mb-2">
                            <strong className="text-black">{info.segment}:</strong> {info.description}
                        </li>
                    ))}
                </ul>
            </div> */}

            {/* on the base of buy sell */}
            {/* <div className="flex flex-col items-start gap-4 self-stretch bg-[#FFF] pt-8 pl-1">
                <div className="text-base lg:text-xl font-bold mb-2 text-black">{symbol} investing rating</div>
                <div className="flex items-start gap-[51px] self-stretch">
                    <div className="flex flex-col items-center gap-2">
                        <div className="self-stretch text-[#414141] font-Inter text-base lg:text-xl font-bold">
                            Mater rating:
                        </div>
                        <div className="flex items-center gap-2">
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                        </div>
                    </div>

                    <div className="text-[#414141] font-Inter text-sm lg:text-base font-medium">
                        {symbol} Industries has an operating revenue of Rs.
                        {putComma(seoData?.keyIndicators?.marketCapital)} on a trailing 12-month basis. An annual
                        revenue growth of 3% is not great, Pre-tax margin of 12% is healthy, ROE of 8% is fair but needs
                        improvement. The company has a reasonable debt... (+)
                    </div>
                </div>
                <div className="flex justify-between items-center self-stretch pt-4">
                    <div className="flex flex-col items-start gap-2">
                        <div className="text-[#414141] font-Inter text-base lg:text-xl font-medium">EPS strength:</div>
                        <div className="flex items-center gap-2">
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                        </div>
                    </div>
                    <div className="flex flex-col items-start gap-2">
                        <div className="text-[#414141] font-Inter text-base lg:text-xl font-medium">Price strength:</div>
                        <div className="flex items-center gap-2">
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                        </div>
                    </div>
                    <div className="flex flex-col items-start gap-2">
                        <div className="text-[#414141] font-Inter text-base lg:text-xl font-medium">Buyer demand</div>
                        <div className="flex items-center gap-2">
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                        </div>
                    </div>
                    <div className="flex flex-col items-start gap-2">
                        <div className="text-[#414141] font-Inter text-base lg:text-xl font-medium">Group rank</div>
                        <div className="flex items-center gap-2">
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-blue-700" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                            <IoIosStar className="w-6 h-6 text-gray-300" size={20} />
                        </div>
                    </div>
                </div>
            </div> */}

            {/* <div className="flex w-full flex-col items-start gap-6 py-8">
                <div className="flex flex-col items-start gap-1 self-stretch">
                    <div className="self-stretch text-black font-Inter text-base lg:text-xl font-bold">
                        Measurement of {symbol}
                    </div>
                    <div className="self-stretch text-[#747474] [font-family:Inter] text-sm lg:text-base font-medium">
                        {symbol} management is what makes it one of India’s greatest firms. The {symbol} market share
                        price is heavily influenced by its management and all its employees. The following is {symbol}
                        hierarchical management:
                    </div>
                </div>
                <div className="border rounded-lg overflow-hidden min-w-full">
                    <table className="w-full text-left text-gray-800">
                        <thead>
                            <tr className="bg-white">
                                <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                    Designation
                                </th>
                                <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                    Name
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            {managementData.map((item, index) => (
                                <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                                    <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                        {item.designation}
                                    </td>
                                    <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                        {item.name}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div> */}

            <div className="my-6">
                <h2 className="text-base lg:text-xl font-bold mb-1 self-stretch text-black font-Inter">
                    {`Shareholding Pattern of ${symbol} Shares In Stock Market`}
                </h2>
                <p className="text-[#747474] mb-4 self-stretch font-Inter text-sm lg:text-base font-medium">
                    The below depicted shareholding pattern is as per the {symbol} Industries Ltd. Share Price Market of{" "}
                    {moment(shareHoldingData?.[0]?.quarter, "MMM' YY").format("MMMM YYYY")}.
                </p>
                <div className="border rounded-lg overflow-hidden">
                    <table className="w-full text-left text-gray-800">
                        <tbody>
                            {shareholdingPattern.map((item, index) => (
                                <tr key={index} className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}>
                                    <td className="px-6 py-3 text-black font-Inter text-sm font-semibold max-w-[86px] min-w-[86px]">
                                        {item.type}
                                    </td>
                                    <td className="px-6 py-3 text-black font-Inter text-sm font-semibold max-w-[86px] min-w-[86px]">
                                        {item.percentage}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>

            {/* <div className="mb-6">
                <h2 className="text-base lg:text-xl font-bold mb-4">{symbol} Company Location</h2>
                <ul className="list-disc pl-6 text-[#747474] flex-[1_0_0]  font-Inter text-sm lg:text-base font-semibold">
                    {companyContactInfo.map((info, index) => (
                        <li key={index}>{info}</li>
                    ))}
                </ul>
                <div className="flex items-center gap-2.5 self-stretch px-0 pt-6">
                    <ul className="list-disc pl-6 text-[#747474] flex-[1_0_0]  font-Inter text-sm lg:text-base font-semibold">
                        {otherCompanyInfo.map((info, index) => (
                            <li key={index}>{info}</li>
                        ))}
                    </ul>
                </div>
            </div> */}
            <div className="border rounded-lg overflow-hidden mb-6">
                <div className="bg-white px-4 py-2 font-semibold text-black font-Inter text-sm lg:text-base capitalize">
                    Don't Miss!!!
                </div>
                <table className="w-full text-left text-gray-800">
                    <tbody>
                        {peerComparison
                            ?.map((ele) => ({ label: ele?.symbol ?? ele?.bseSymbol, value: ele?.name }))
                            ?.map((item, index) => (
                                <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                                    <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold max-w-[86px] min-w-[86px]">
                                        {item.label}
                                    </td>
                                    <td className="px-6 py-3 text-primary font-Inter text-xs lg:text-sm font-semibold max-w-[86px] min-w-[86px]">
                                        <Link href={Actions.toStockDetail(item.label, item.value)}>{item.value}</Link>
                                    </td>
                                </tr>
                            ))}
                    </tbody>
                </table>
            </div>

            <div className="border rounded-lg overflow-hidden mb-6">
                <div className="bg-white px-4 py-2 font-semibold text-black font-Inter text-xs lg:text-base capitalize">
                    {`${symbol} Share Background`}
                </div>
                <table className="w-full text-left text-gray-800">
                    <tbody>
                        {[
                            { label: "Face Value", value: putComma(seoData?.keyIndicators?.faceValue) },
                            { label: "ISIN", value: putComma(data?.isin) },
                            { label: "Market Lot", value: putComma(data?.lotSize ?? 1) },
                            { label: "Instrument", value: data?.instrumentName }
                        ]?.map((item, index) => (
                            <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                                <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold max-w-[86px] min-w-[86px]">
                                    {item.label}
                                </td>
                                <td className="px-6 py-3 text-black font-Inter text-xs lg:text-sm font-semibold max-w-[86px] min-w-[86px]">
                                    {item.value}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
            <div className="flex min-w-full flex-col items-start gap-6">
                {/* <div className="flex flex-col items-start gap-1 self-stretch">
                    <p className="self-stretch text-[#747474] font-Inter text-sm lg:text-base font-medium">
                        Rs. — In Crores
                    </p>
                    <p className="h-8 self-stretch text-black font-Inter text-base lg:text-xl font-bold">
                        {symbol} Industries Limited Stock Returns in 2020 and 2021
                    </p>
                </div> */}
                {yearEndingMonth?.length > 0 && (
                    <div className="border rounded-lg overflow-hidden mb-6 min-w-full">
                        <table className="w-full text-left text-gray-800">
                            <thead>
                                <tr className="bg-white">
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                        Month & Year
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                        Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                        Open Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                        High Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                        Low Price (INR)
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                        Volume
                                    </th>
                                    <th className="px-6 py-3 text-black font-Inter text-sm lg:text-base font-semibold">
                                        Change %
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {yearEndingMonth?.map((row, index) => (
                                    <tr key={index} className={index % 2 === 0 ? "bg-gray-100" : "bg-white"}>
                                        <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                            {row.monthYear}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                            {putComma(row.price)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                            {putComma(row.openPrice)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-sm font-semibold2">
                                            {putComma(row.highPrice)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                            {putComma(row.lowPrice)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                            {putComma(row.volume, 0)}
                                        </td>
                                        <td className="px-6 py-3 text-black font-Inter text-sm font-semibold">
                                            {putComma(row.change)}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
            {/*<div className="mb-6">
                <h2 className="text-base lg:text-xl font-bold mb-2 self-stretch text-black font-Inter">
                    Summary of {symbol} Share Price in 2020 and 2021
                </h2>
                <div className="text-sm font-semibold list-none text-[#747474] font-Inter flex flex-col gap-1">
                    <li>Highest – 2,751.00</li>
                    <li>Lowest – 867.43</li>
                    <li>Difference – 1,883.57</li>
                    <li>Average – 1,962.88</li>
                    <li>Chg. % – 57.89</li>
                </div>
            </div>
            <div className="mb-6">
                <h2 className="text-base lg:text-xl font-bold mb-2 self-stretch text-black font-Inter">
                    {symbol} Industries Limited Listings and Indices
                </h2>
                <div className="text-black font-Inter text-sm lg:text-base font-semibold mb-1">Key Dates</div>
                <div className="text-sm font-semibold list-none text-[#747474] font-Inter flex flex-col gap-1">
                    <li>Incorporation Date – 08/05/1973</li>
                    <li>Public Issue Date – 28/06/1975</li>
                    <li>Year Ending Month – March</li>
                    <li>AGM Month – June</li>
                </div>
                <div className="text-black font-Inter text-sm lg:text-base font-semibold mt-3 mb-1">
                    Listing Information
                </div>
                <div className="text-sm font-semibold list-none text-[#747474] font-Inter flex flex-col gap-1">
                    <li>Face Value – 10.0</li>
                    <li>Market Lot of Equity Shares – 15</li>
                    <li>BSE Code – 500325</li>
                    <li>BSE Group – A</li>
                    <li>Ril Share Indices</li>
                </div>
            </div>
            <div className="flex flex-col items-start gap-2 self-stretch">
                <div className="self-stretch text-black font-Inter text-base lg:text-xl font-bold capitalize">
                    {symbol} Industries Share Forms under the Following Indices:
                </div>
                <div className="flex items-start gap-2.5 self-stretch px-0 py-1 flex-col">
                    <ul>
                        {Indices.map((item, index) => (
                            <li
                                key={index}
                                className="flex-[1_0_0] text-[#747474] font-Inter text-sm lg:text-base font-semibold"
                            >
                                •{item.value}
                            </li>
                        ))}
                    </ul>
                </div>
            </div> 
            <div className="flex flex-col items-start gap-2 self-stretch pb-2 pt-8">
                <div className="self-stretch text-black font-Inter text-base lg:text-xl font-bold capitalize">
                    Company Listed On
                </div>
                <div className="flex items-center gap-2.5 self-stretch px-0 py-1">
                    <ul>
                        {stockExchanges.map((item, index) => (
                            <li
                                key={index}
                                className="flex-[1_0_0] text-[#747474] font-Inter text-sm lg:text-base font-semibold"
                            >
                                •{item.value}
                            </li>
                        ))}
                    </ul>
                </div>
            </div>*/}
            {!isPaidUserPage && (
                <div className="pb-4">
                    <Image
                        alt="demo image"
                        src={
                            "https://storage.googleapis.com/production-univest/pn_images/1743077058544_trade_carddd.jpeg"
                        }
                        width={1200}
                        height={600}
                        className="object-contain rounded-lg md:rounded-2xl cursor-pointer"
                        onClick={() => {
                            router.push("/user/payment");
                            Mixpanel.track("banner_clicked", {
                                page: "stock_page",
                                widget: "free_trades",
                                cta_text: "free_trades"
                            });
                        }}
                    />
                </div>
            )}
            <div className="flex flex-col items-start gap-2 self-stretch">
                <div className="self-stretch text-[color:var(--Neutral-900,#202020)] [font-family:Inter] text-base lg:text-xl font-bold capitalize">
                    {`Should you invest in ${symbol} Industries Limited?`}
                </div>
                <div className="flex items-center gap-2.5 self-stretch px-0 py-1 list-none">
                    <div className="text-[#747474] font-Inter text-sm lg:text-base font-semibold flex flex-col gap-4">
                        <li>
                            Every milestone results from a lot of hard work, effort, and making the correct decisions,
                            but patience is essential.
                        </li>
                        <li>
                            Patience is the key to success in the share market, which is also important in attaining
                            benefits on {symbol} share price.
                        </li>
                        <li>
                            In terms of investment, the investor’s patience pays off with a high return, which is why
                            long-term investors are the most successful.
                        </li>
                        <li>
                            {`${symbol} Industries has produced a great return to the last year and is reaching new
                            milestones daily; it has become the first Indian firm to attain a market capitalisation of
                            ${putComma(seoData?.keyIndicators?.marketCapital, 0)} Cr.`}
                        </li>
                    </div>
                </div>
                {/* <div className="flex items-center gap-2.5 self-stretch px-0 py-1">
                    <div className="text-black font-Inter text-sm lg:text-base font-semibold">Listing Information</div>
                </div>
                <div className="flex items-center gap-2.5 self-stretch px-0 py-1">
                    <div className="flex flex-col text-[#747474] font-Inter text-sm lg:text-base font-semibold gap-4 list-none">
                        <li>8.68% in one month</li>
                        <li> 102.94 per cent after 6 months</li>
                        <li>89.65 per cent after one year</li>
                        <li>
                            Many people are attracted by a person’s or a company’s short-term success, but behind that
                            achievement is a lot of effort and patience, which he has put in for a long time.
                        </li>
                        <li>
                            The chart data depicts how the {symbol} industries stock taxed the investor’s patience from
                            October 2007 to May 2017 since the firm was unable to profit for the investor throughout
                            this time frame.
                        </li>
                        <li>
                            However, those investors who stayed with the firm for a long time could make a large profit.
                        </li>
                    </div>
                </div> */}
            </div>
        </div>
    );
};
export default StocksExtra;
